import { motion } from "framer-motion";
import { IMAGES } from "@/lib/site";

const TOURS = [
  {
    img: IMAGES.tourHimachal,
    alt: "Snowcapped Himalayas with pine valleys in Himachal Pradesh",
    tag: "Domestic Circuit",
    tagCls: "bg-amber-600/90",
    title: "Himachal & Kashmir Serenity",
    points: ["Shimla, Manali, Rohtang & Srinagar", "3-Star/4-Star stays with breakfast & dinner", "Private cab transfers included"],
    dot: "bg-amber-700",
    price: "Customized Quotes",
    ctaCls: "text-amber-800 hover:text-amber-900 border-amber-300 bg-amber-50",
  },
  {
    img: IMAGES.tourBeach,
    alt: "Turquoise beach in South East Asia with a longtail boat",
    tag: "International Gateway",
    tagCls: "bg-teal-600/90",
    title: "Dubai, Thailand & Bali Escapes",
    points: ["Return airfare & tourist visa stamping", "Curated city tours & island excursions", "Indian meal plan options available"],
    dot: "bg-teal-700",
    price: "Customized Quotes",
    ctaCls: "text-teal-800 hover:text-teal-900 border-teal-300 bg-teal-50",
  },
  {
    img: IMAGES.tourHeritage,
    alt: "Heritage resort courtyard in Rajasthan illuminated at night",
    tag: "Corporate & Group",
    tagCls: "bg-indigo-700/90",
    title: "Executive Offsites & Group Trips",
    points: ["Dedicated group flight & coach charters", "Conference hall & team-building logistics", "GST billing & end-to-end event coordinator"],
    dot: "bg-indigo-800",
    price: "Corporate Rates",
    ctaCls: "text-indigo-800 hover:text-indigo-900 border-indigo-300 bg-indigo-50",
  },
];

export const Packages = () => (
  <section id="packages" className="py-20 bg-stone-50" data-testid="packages-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
        <div>
          <span className="text-xs font-bold tracking-widest text-amber-800 uppercase">Curated Departures</span>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-stone-900 mt-2 font-serif-display">
            Tours crafted for every traveller
          </h2>
        </div>
        <p className="text-stone-600 max-w-md mt-4 md:mt-0 text-sm">
          Hand-picked hotel stays, verified local transfers, and flexible daily pacing designed so you can enjoy every minute.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {TOURS.map((t, i) => (
          <motion.div
            key={t.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="bg-white rounded-2xl overflow-hidden border border-stone-200 shadow-sm hover:shadow-md transition-shadow flex flex-col"
            data-testid={`tour-card-${i + 1}`}
          >
            <div className="aspect-[16/10] relative flex items-end p-6 overflow-hidden">
              <img src={t.img} alt={t.alt} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="relative z-10 text-white">
                <span className={`text-xs font-bold uppercase tracking-wider ${t.tagCls} px-2.5 py-1 rounded`}>{t.tag}</span>
                <h3 className="text-xl font-bold mt-2">{t.title}</h3>
              </div>
            </div>
            <div className="p-6 flex-1 flex flex-col justify-between space-y-6">
              <ul className="space-y-2 text-sm text-stone-600">
                {t.points.map((p) => (
                  <li key={p} className="flex items-center gap-2">
                    <span className={`w-1.5 h-1.5 rounded-full ${t.dot}`} /> {p}
                  </li>
                ))}
              </ul>
              <div className="pt-4 border-t border-stone-100 flex items-center justify-between">
                <div>
                  <span className="text-xs text-stone-700 block">Pricing</span>
                  <span className="text-base font-bold text-stone-900">{t.price}</span>
                </div>
                <a
                  href="#contact"
                  data-testid={`tour-card-${i + 1}-cta`}
                  className={`text-xs font-semibold border px-3 py-1.5 rounded-lg transition-colors ${t.ctaCls}`}
                >
                  Request Itinerary
                </a>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
